import React, { Component } from 'react';
import { ActionMeta, InputActionMeta, MultiValue, PropsValue, SingleValue } from 'react-select';
import AsyncSelect from 'react-select/async';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import Option from '../../interfaces/Option/Option';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import { CustomDropdownIndicator, CustomInput } from '../FormFieldSelect/FormFieldSelectPartials';
import { formFieldSelectStylesForCustomerDataPage } from '../FormFieldSelect/FormFieldSelectStyles';
import FormFieldSelectPLZProps from './FormFieldSelectPLZ.props';
import FormFieldSelectPLZState from './FormFieldSelectPLZ.state';

export default class FormFieldSelectPLZ extends Component<FormFieldSelectPLZProps, FormFieldSelectPLZState> implements FormFieldFunctions {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;
    private selectElement: React.RefObject<HTMLDivElement>;

    constructor(props: FormFieldSelectPLZProps) {
        super(props);
        this.state = {
            selected: this.props.selected,
            disabled: this.props.disabled || false,
            options: this.props.selected
                ? [{
                    label: this.props.selected,
                    value: this.props.selected
                }]
                : []
        };

        this.selectElement = React.createRef<HTMLDivElement>();
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.getPLZList = this.getPLZList.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.isValid = this.isValid.bind(this);
        this.toggleValidationError = this.toggleValidationError.bind(this);
    }

    handleSelectChange(newValue: MultiValue<Option> | SingleValue<Option>, actionMeta: ActionMeta<Option>) {
        this.setState({
            selected: (newValue as Option).value,
        }, this.onBlur);
    }

    updateAndNotify = () => {
        this.setState({
            selected: this.props.selected,
            options: this.props.selected
                ? [{
                    label: this.props.selected,
                    value: this.props.selected
                }]
                : []
        });
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldSelectPLZProps): Snapshot {
        return { notifyRequired: prevProps.selected !== this.props.selected };
    }

    componentDidUpdate(prevProps: FormFieldSelectPLZProps, prevState: FormFieldSelectPLZState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
    }

    onBlur() {
        if (this.isValid()) {
            this.toggleValidationError(false);
            if (this.props.formFieldCity?.state.plz !== this.state.selected) {
                this.props.formFieldCity?.resetField();
                this.props.formFieldCity?.setState({
                    plz: this.state.selected
                }, () => {
                    this.props.formFieldCity?.updateCityWithPLZFromState();
                    // this.props.formFieldStreet?.getFocusFromPLZ();
                });
            }
        }
    }

    isValid() {
        if (this.props.required && (this.state.selected === undefined || this.state.selected.trim() === '')) {
            return false;
        }

        if (!(this.state.options && this.state.options.findIndex(option => option.value === this.state.selected) >= 0)) {
            return false;
        }

        return true;
    }

    toggleValidationError(show: boolean) {
        if (show) {
            this.selectElement.current?.parentElement?.classList.add('form__field--error');
        } else {
            this.selectElement.current?.parentElement?.classList.remove('form__field--error');
        }
    }

    async getPLZList(newValue: string): Promise<Option[]> {
        if (newValue.trim() === '') {
            return [] as Option[];
        }

        const response = await this.context.requestProvider.postData(
            '/jportal/wsrest/recherche3/addressSuggestPlz',
            {
                portalId: 'jurisw',
                plzPrefix: newValue,
                r3ID: (new Date()).toISOString(),
            }
        );

        if (response && response.status === 200) {
            const newPlzList = (await response.json()).list || [];
            const upgradedPlzList = newPlzList.map((plz: string) => {
                return {
                    label: plz,
                    value: plz
                } as Option
            }) as Option[];
            // console.log(newPlzList);
            // console.log(upgradedPlzList);
            this.setState({
                selected: newValue,
                options: upgradedPlzList,
            });
            return upgradedPlzList;
        }

        return [] as Option[];
    }

    getValue() {
        return this.state.selected;
    }

    render(): React.ReactNode {
        return (
            <div data-testid="FormFieldSelectPLZ"
                className={
                    "select"
                    + (!!this.state.selected && this.state.selected !== 'default' ? " select--option-selected" : "")
                }
                ref={this.selectElement}>
                <div className="select__inner">
                    <div className="select__content">
                        {
                            this.props.label &&
                            <label className="select__label" htmlFor={this.props.id}>{this.props.label}</label>
                        }
                        <AsyncSelect
                            inputId={this.props.id}
                            tabIndex={undefined}
                            tabSelectsValue={false}
                            maxLength={this.props.maxLength}
                            name={this.props.name || this.props.id}
                            loadOptions={this.getPLZList}
                            value={(this.state.selected && {
                                label: this.state.selected,
                                value: this.state.selected
                            } as PropsValue<Option>) || undefined}
                            defaultOptions={this.state.options || ([] as Option[])}
                            isDisabled={
                                (this.props.isLoggedIn && this.state.selected !== undefined)
                            }
                            onInputChange={(newValue: string, actionMeta: InputActionMeta) => {
                                // console.log(actionMeta)
                                if (actionMeta.action === 'input-change') {
                                    this.setState({
                                        selected: newValue
                                    });
                                }
                            }}
                            inputValue={this.state.selected}
                            cacheOptions
                            // onInputChange={this.getPLZList}
                            placeholder={this.props.label}
                            // defaultMenuIsOpen={true} // for debug purposes
                            noOptionsMessage={() => "Keine Optionen"}
                            closeMenuOnSelect={true}
                            isMulti={false}
                            onChange={this.handleSelectChange}
                            onBlur={this.onBlur}
                            styles={formFieldSelectStylesForCustomerDataPage}
                            components={{
                                DropdownIndicator: CustomDropdownIndicator,
                                Input: CustomInput,
                            }} />
                    </div>
                </div>
            </div>
        );
    }
}
